import ConditionNode from './ConditionNode/ConditionNode';
import PlusNode from './PlusNode/PlusNode';
import TriggerNode from './TriggerNode/TriggerNode';
import EmailBuilderNode from './EmailBuilderNode/EmailBuilderNode';
import NotificationBuilderNode from './NotificationBuilderNode/NotificationBuilderNode';
import CaseBuilderNode from './CaseBuilderNode/CaseBuilderNode';
import ProductBuilderNode from './ProductBuilderNode/ProductBuilderNode';
import ActionNode from './ActionNode/ActionNode';
import EdgeLine from '../ui/EdgeLine/EdgeLine';

export const workflowNodeTypes = {
  trigger: TriggerNode,
  condition: ConditionNode,
  plus: PlusNode,
  action: ActionNode,
  emailBuilder: EmailBuilderNode,
  notificationBuilder: NotificationBuilderNode,
  caseBuilder: CaseBuilderNode,
  productBuilder: ProductBuilderNode,
};

export const workflowEdgeTypes = { standard: EdgeLine };
